import angular from 'angular';

import CheckEventCountModule from './check-event-count';

export default angular
    .module('application.scene.authorized.scene.calendar.directive', [
        CheckEventCountModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/directive/index.js